<template>
    <div class="card">
        <div class="card-header border-bottom">
            <i class="fas fa-user-check me-2"></i>{{ TR.roles }}
        </div>

        <div class="card-body">
            <DADataTable
                ref="role_table_ref"
                v-if="tableData"
                :tableData="tableData"
                :tableOptions="tableOptions"
            />
        </div>

    </div>
</template>


<script>
    import { onMounted, ref, watchEffect } from "vue";

    import { useStore } from "@/system_modules/store";
    import moment from "moment-timezone";

    import { G, ajax } from "@/_common";
    import { routes } from "@/system_modules/router/index";
    // import { useToast } from "primevue/usetoast";
    import DADataTable from "@/components/table/DADataTable";

    export default {
        title: "role",
        name: 'RolePage',
        components: {
            DADataTable,
        },
        setup() {
            const store = useStore();
            // const toast = useToast();

            const tableData = ref([]);
            const tableOptions = ref();
            const role_table_ref = ref();
            const TR = ref({});

            // const route_list = routes.sort(function(a, b){return a.name.localeCompare(b.name)}).filter(e => !G.ignored_routes.includes(e.name) ).map(a => a.name);
            const route_list = routes.filter(e => !G.ignored_routes.includes(e.name) ).map(a => a.name);

            onMounted(async () => {
                await ajax({
                    url: store.getRoles(),
                    success: (e) => {
                        let res = e.data || null;
                        if (res) {
                            tableData.value = res;
                            // tableData.value.forEach(x => x.create_date = new Date(moment.utc(x.create_date).tz(G.systemData.timezone?.value).format(G.datetime_format['pg_datetime'])));
                            // res.map((a) => {
                            //     return {
                            //         value: a.id,
                            //         label: `${a.name}`,
                            //     };
                            // });
                        } else {
                            // G.removeClientData("AUTH_TOKEN");
                        }
                    }
                });

            });


            watchEffect(() => {
                TR.value = store.getTranslation();

                tableOptions.value = {
                    // row_total: false,
                    // rows: 5,

                    header_buttons:[
                        {
                            private: G.privateIfNotPermission("add"),
                            label: TR.value.add_title,
                            icon: 'fas fa-plus me-1',
                            class: 'btn-primary',
                            eventCallback: () => {
                                G.showModal({
                                    title: TR.value.add_title,
                                    // page: 'components/table/DynamicTable2',
                                    page: "system_modules/role/RolePermission",
                                    modal_width: 40,
                                    data: {
                                        permission_method: 'add'
                                    },
                                    routes: route_list,
                                    table_columns: [
                                        // {
                                        //     name: "preview_image",
                                        //     title: TR.value.preview,
                                        //     // value: (e) => e.image,
                                        //     value: "image",
                                        //     field_type: "label",
                                        // },
                                        // {
                                        //     name: "image",
                                        //     title: TR.value.image,
                                        //     // value: (e) => e.image,
                                        //     field_type: "image",
                                        //     fileSelectMode: 'basic',
                                        //     // fileSelectMode: 'advanced',
                                        //     fileMaxSize: G.uploadedFileSize,
                                        //     fileLimit: 1,
                                        //     fileMultiple: false,
                                        // },
                                        {
                                            name: "name",
                                            title: TR.value.name,
                                            field_type: "text",
                                        },
                                        {
                                            name: "slug",
                                            title: TR.value.slug,
                                            field_type: "text",
                                        },
                                        // {
                                        //     name: "status",
                                        //     title: TR.value.status,
                                        //     field_type: "text",
                                        // },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("add"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.name != '' ){
                                                            let d = [];
                                                            let d1 = [];
                                                            for(let r in e.role_permission){
                                                                // if( e.role_permission[r].length ){
                                                                //     d.push({'route': r, 'action': e.role_permission[r]});
                                                                // }
                                                                d1 = [];
                                                                for( let a in e.role_permission[r] ){
                                                                    if( e.role_permission[r][a] ){
                                                                        d1.push(a);
                                                                    }
                                                                }
                                                                if( d1.length ){
                                                                    d.push({'route': r, 'action': d1});
                                                                }
                                                            }

                                                            let role_data = {
                                                                name: e.name,
                                                                slug: e.slug || e.name,
                                                                // permission: JSON.stringify(d),
                                                                permission: JSON.stringify(d),
                                                                status: e.status || 1
                                                            };
                                                            // if( e.image != null && typeof e.image !== 'object' )
                                                            //     store_data.image = e.image;

                                                            // formData.append("data", JSON.stringify(store_data));

                                                            await ajax({
                                                                url: store.getRoles(),
                                                                method: 'post',
                                                                content_type: 'application/json; charset=UTF-8',
                                                                data: role_data,
                                                                success: (x) => {
                                                                    let res = x.data || null;
                                                                    if ( x.status == 200 && res) {
                                                                        // res.create_date = new Date(res.create_date);
                                                                        tableData.value.unshift(res);
                                                                        G.alert.success(TR.value.msg_add_success);
                                                                    }
                                                                    else
                                                                        G.alert.error(res.detail);
                                                                },
                                                                // error: (x) => {
                                                                //     var res = x.response || {};
                                                                //     if( res.status == 422 ){
                                                                //         G.alert.warning(G.getErrorMessages(res.data.detail));
                                                                //     }
                                                                //     else
                                                                //         G.alert.error(TR.value.msg_add_failed);
                                                                // }
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else{
                                                            G.alert.warning(TR.value.input_error);
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        }
                    ],
                    row_buttons: [
                        {
                            private: e => G.hideAdminRecord(e),
                            label: "",
                            title: TR.value.remove,
                            icon: "fas fa-trash",
                            class: "text-danger",
                            eventCallback: (data) => {
                                G.alert.confirm({ title: TR.value.warning, msg: TR.value.msg_remove_role, yesTitle: TR.value.yes, yes: async () => {
                                    await ajax({
                                        url: store.getRolesUpdate(data.id),
                                        method: 'delete',
                                        success: (e) => {
                                            let res = e.data || null;
                                            tableData.value.filter((x, i) => { if (x.id === data.id) tableData.value.splice(i, 1); } );
                                            G.alert.success(res.detail);
                                        },
                                        // error: (e) => {
                                        //     let res = e.response || null;
                                        //     G.alert.error(G.getErrorMessages(res.data.detail));
                                        // }
                                    });
                                }, yesIcon: 'fas fa-check', noIcon: 'fas fa-ban', noTitle: TR.value.no, no: () => {}, })
                            },
                        },
                        {
                            private: e => G.hideAdminRecord(e),
                            label: "",
                            title: TR.value.edit,
                            // icon: "fas fa-pencil-alt",
                            // class: "btn-primary",
                            icon: "fas fa-" + ( G.userHavePermission("update") ? 'pencil-alt' : 'search' ),
                            class: "text-" + ( G.userHavePermission("update") ? 'primary' : 'info' ),
                            eventCallback: (data) => {
                                data.permission_method = 'update';

                                G.showModal({
                                    title: TR.value.edit_title,
                                    subTitle: `<span class="text-danger1">${data.name}</span> - ${G.formatLocale(new Date(data.create_date))}`,
                                    modal_width: 40,
                                    // page: "components/table/DynamicTable2",
                                    page: "system_modules/role/RolePermission",
                                    data: data,
                                    routes: route_list,
                                    table_columns: [
                                        // {
                                        //     name: "preview_image",
                                        //     title: TR.value.preview,
                                        //     // value: (e) => e.image,
                                        //     value: "image",
                                        //     field_type: "label",
                                        // },
                                        // {
                                        //     name: "image",
                                        //     title: TR.value.image,
                                        //     value: (e) => e.image,
                                        //     field_type: "image",
                                        //     fileSelectMode: 'basic',
                                        //     fileMaxSize: G.uploadedFileSize,
                                        //     fileLimit: 1,
                                        //     fileMultiple: false,
                                        // },
                                        {
                                            name: "id",
                                            title: TR.value.id,
                                            value: "id",
                                        },
                                        {
                                            name: "name",
                                            title: TR.value.name,
                                            value: (e) => e.name,
                                            field_type: "text",
                                        },
                                        {
                                            name: "slug",
                                            title: TR.value.slug,
                                            value: (e) => e.slug,
                                            field_type: "text",
                                        },
                                        // {
                                        //     name: "status",
                                        //     title: TR.value.status,
                                        //     value: (e) => e.status,
                                        //     field_type: "text",
                                        // },
                                        {
                                            name: "create_date",
                                            value: (e) => G.dateToStr(e.create_date, 'datetime'),
                                            title: TR.value.create_date,
                                            field_type: "label",
                                        },
                                    ],
                                    toolbar: {
                                        leftSide: {
                                            buttons: [
                                                {
                                                    label: TR.value.close,
                                                    icon: "fas fa-times",
                                                    class: "btn-secondary",
                                                    eventCallback: (el) => {
                                                        G.closeModal(el);
                                                    },
                                                },
                                                {
                                                    private: G.privateIfNotPermission("update"),
                                                    label: TR.value.save,
                                                    icon: "fas fa-save",
                                                    class: "btn-primary",
                                                    eventCallback: async (res) => {
                                                        let e = res.newdata;

                                                        if( e && e.name != '' ){
                                                            let d = [];
                                                            let d1 = [];
                                                            for(let r in e.role_permission){
                                                                // if( e.role_permission[r].length ){
                                                                //     d.push({'route': r, 'action': e.role_permission[r]});
                                                                // }
                                                                d1 = [];
                                                                for( let a in e.role_permission[r] ){
                                                                    if( e.role_permission[r][a] ){
                                                                        d1.push(a);
                                                                    }
                                                                }
                                                                if( d1.length ){
                                                                    d.push({'route': r, 'action': d1});
                                                                }
                                                            }

                                                            let role_data = {
                                                                name: e.name,
                                                                slug: e.slug || e.name,
                                                                permission: JSON.stringify(d),
                                                                status: e.status || 1,
                                                            };

                                                            await ajax({
                                                                url: store.getRolesUpdate(data.id),
                                                                method: 'patch',
                                                                content_type: 'application/json; charset=UTF-8',
                                                                data: role_data,
                                                                success: (x) => {
                                                                    let res1 = x.data || null;
                                                                    if (res1) {
                                                                        G.parsePermission(res1.slug, res1.permission);
                                                                        // res1.create_date = new Date(res1.create_date);
                                                                        tableData.value.forEach(
                                                                            (s) => { if ( s.id === res1.id ) { s = res1; } }
                                                                        );
                                                                        for (let a in res1) {
                                                                            data[a] = res1[a];
                                                                        }
                                                                        G.alert.success(TR.value.msg_update_success);
                                                                    }
                                                                },
                                                                // error: (x) => {
                                                                //     var res1 = x.response || {};
                                                                //     if( res1.status == 422 ){
                                                                //         G.alert.warning(G.getErrorMessages(res1.data.detail));
                                                                //     }
                                                                //     else
                                                                //         G.alert.warning(res1.data.detail);
                                                                // }
                                                            });
                                                            G.closeModal(res);
                                                        }
                                                        else{
                                                            G.alert.warning({msg: TR.value.input_error});
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    },
                                });
                            },
                        },
                    ],
                    data_table_columns: [
                        // {
                        //     name: "email",
                        //     value: "email",
                        //     title: TR.value.email,
                        //     exportable: true,
                        //     sortable: true,
                        //     showFilterMatchModes: true,
                        //     // filter: true,
                        //     // data_type: "text",
                        //     // filter_placeholder: TR.value.code,
                        // },
                        // {
                        //     name: "image",
                        //     value: (e) => `<img
                        //                             src="${
                        //                                 e.image
                        //                                     ? e.image
                        //                                     : "/assets/img/noimg.png"
                        //                             }"
                        //                             alt="${e.image}"
                        //                             class="border img-circle-cover"
                        //                         />`,
                        //     title: TR.value.image,
                        //     exportable: false,
                        //     sortable: false,
                        //     filter: false,
                        // },
                        {
                            name: "id",
                            title: TR.value.id,
                            value: "id",
                            class: 'text-center',
                            filter: false,
                        },
                        {
                            name: "name",
                            value: (e) => e.name,
                            title: `${TR.value.name}`,
                        },
                        {
                            name: "slug",
                            value: (e) => e.slug,
                            title: `${TR.value.slug}`,
                        },
                        {
                            name: "create_date",
                            value: "create_date",
                            title: TR.value.create_date,
                            filters: {
                                operator: "or",
                                constraints: [{ value: null, matchMode: "dateBefore" }],
                            },
                            filter_format: 'dd.mm.yy',
                            data_type: "date",
                            filter_mode: "datetime",
                        },
                    ],
                };

            });

            return {
                G,
                TR,
                role_table_ref,
                tableData,
                tableOptions,
            };
        },
    };
</script>

